import { getApiUrl } from "../../services/apiConfig.js";
/* Gestão institucional aditiva. Nenhuma ação de exclusão. */
(function () {
  "use strict";

  const css = "/static/css/institutions-v1.css?v=scope-7918dab5dfba";
  function node(tag, cls, text) {
    const createElementResult = document.createElement(tag);
    if (cls) createElementResult.className = cls;
    if (text !== undefined) createElementResult.textContent = text;
    return createElementResult;
  }
  function button(text, index, cls = "di-button") {
    const nodeResult = node("button", cls, text);
    nodeResult.type = "button";
    nodeResult.onclick = index;
    return nodeResult;
  }
  const money = (value) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(value || 0) / 100);
  function mount(root, passed, portal) {
    if (!document.querySelector("link[data-institutions]")) {
      const element = document.createElement("link");
      element.rel = "stylesheet";
      element.href = css;
      element.dataset.institutions = "1";
      document.head.append(element);
    }
    const stored = () => {
      try {
        return JSON.parse(sessionStorage.getItem("auth_session") || "null");
      } catch {
        return null;
      }
    };
    const session = passed && passed.tipo ? passed : stored();
    const role = session?.tipo;
    const identity = role + ":" + String(session?.data?.id || "admin");
    let alive = true,
      sequence = 0,
      groupLoading = false,
      childDispose = null,
      selected = portal
        ? Number(portal.id || session?.data?.institution_id)
        : null;
    const controllers = new Set();
    root.classList.add("di-root");
    async function api(
      resource,
      index = 0,
      method = "GET",
      data = null,
      query = {},
    ) {
      const now = stored();
      if (now && now.tipo + ":" + String(now.data?.id || "admin") !== identity)
        throw Error(
          "A conta mudou nesta janela. Atualize a página para continuar.",
        );
      const controller = new AbortController();
      controllers.add(controller);
      const dataAtual2 = {
        "Content-Type": "application/json",
      };
      if (role === "admin") {
        if (session?.data?.token)
          dataAtual2["X-Admin-Token"] = session.data.token;
        if (session?.data?.learning_admin_token)
          dataAtual2["X-Learning-Token"] = session.data.learning_admin_token;
      } else if (session?.data?.access_token)
        dataAtual2.Authorization = "Bearer " + session.data.access_token;
      try {
        const fetchResult = await fetch(
          getApiUrl(
            "/api/institutions.php?" +
              new URLSearchParams({
                resource,
                id: index,
                ...query,
              }),
          ),
          {
            method,
            headers: dataAtual2,
            body: data ? JSON.stringify(data) : undefined,
            signal: controller.signal,
            credentials: "same-origin",
          },
        );
        const jsonResult = await fetchResult.json();
        if (!fetchResult.ok || jsonResult.status === "error")
          throw Error(jsonResult.message || "Não foi possível carregar.");
        return jsonResult.data;
      } finally {
        controllers.delete(controller);
      }
    }
    function status(value, error = false) {
      if (!alive) return;
      let querySelectorResult = root.querySelector(".di-notice");
      if (!querySelectorResult) {
        querySelectorResult = node("div", "di-notice");
        querySelectorResult.setAttribute("role", "status");
        root.prepend(querySelectorResult);
      }
      querySelectorResult.textContent = value;
      querySelectorResult.dataset.error = error ? "1" : "0";
    }
    function base(title, description, back) {
      root.replaceChildren();
      const nodeResult = node("header", "di-header"),
        left = node("div");
      if (back)
        left.append(button("Voltar às instituições", () => list(), "di-back"));
      left.append(node("h1", null, title), node("p", null, description));
      nodeResult.append(left);
      root.append(nodeResult);
      return nodeResult;
    }
    function field(form, label, name, type, value, opts = {}) {
      const wrap = node("label", "di-field", label),
        input = node(type === "select" ? "select" : "input");
      input.name = name;
      input.setAttribute("aria-label", label);
      if (type !== "select") input.type = type;
      if (type === "password") input.autocomplete = "new-password";
      if (type === "email" || name === "email") input.autocomplete = "off";
      if (type === "select")
        for (const [optionalValue, optionalValueAtual2] of opts.options || []) {
          const nodeResult = node("option", null, optionalValueAtual2);
          nodeResult.value = optionalValue;
          input.append(nodeResult);
        }
      if (type === "checkbox") input.checked = !!value;
      else input.value = value ?? "";
      if (opts.required) input.required = true;
      if (opts.min !== undefined) input.min = opts.min;
      if (opts.maxLength) input.maxLength = opts.maxLength;
      if (opts.minLength) input.minLength = opts.minLength;
      if (opts.step) input.step = opts.step;
      if (opts.note) wrap.append(node("small", null, opts.note));
      wrap.append(input);
      form.append(wrap);
      return input;
    }
    function metric(label, value) {
      const nodeResult = node("div", "di-metric");
      nodeResult.append(node("strong", null, value), node("span", null, label));
      return nodeResult;
    }
    async function action(value, success, refresh) {
      try {
        await value();
        if (!alive) return;
        if (refresh) await refresh();
        status(success);
      } catch (error) {
        status(error.message, true);
      }
    }
    async function list() {
      const gen = ++sequence;
      selected = null;
      base("Instituições", "");
      const toolbar = node("div", "di-list-toolbar"),
        searchWrap = node("label", "di-search-wrap"),
        icon = node("span", "di-search-icon");
      icon.setAttribute("aria-hidden", "true");
      icon.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></svg>';
      const search = node("input", "di-search");
      search.type = "search";
      search.setAttribute("aria-label", "Pesquisar instituição");
      searchWrap.append(icon, search);
      toolbar.append(
        searchWrap,
        button("Nova instituição", () => edit(null), "di-button di-primary"),
      );
      root.append(toolbar);
      const pending = node("p", "di-loading", "Carregando instituições…");
      root.append(pending);
      try {
        const rows = await api("institutions");
        if (!alive || gen !== sequence) return;
        pending.remove();
        rows.sort(
          (left, right) =>
            left.nome.localeCompare(right.nome, "pt-BR", {
              sensitivity: "base",
            }) || Number(left.id) - Number(right.id),
        );
        const panel = node("div", "di-institution-list");
        root.append(panel);
        function paint() {
          panel.replaceChildren();
          const toLocaleLowerCaseResult =
              search.value.toLocaleLowerCase("pt-BR"),
            matches = rows.filter(
              (row) =>
                row.nome
                  .toLocaleLowerCase("pt-BR")
                  .includes(toLocaleLowerCaseResult) ||
                (row.enrollment_code || "")
                  .toLocaleLowerCase("pt-BR")
                  .includes(toLocaleLowerCaseResult),
            );
          const table = node("table", "di-institutions-table"),
            head = node("thead"),
            hdr = node("tr");
          for (const optionalValue of ["Instituição", "Situação", "Gestão"]) {
            const nodeResult = node("th", null, optionalValue);
            nodeResult.scope = "col";
            hdr.append(nodeResult);
          }
          head.append(hdr);
          table.append(head);
          const tbody = node("tbody");
          for (const optionalValue of matches) {
            const nodeResult = node("tr", "di-institution-row");
            nodeResult.dataset.id = optionalValue.id;
            const name = node("td", "di-list-name");
            name.dataset.label = "Instituição";
            name.append(
              button(
                optionalValue.nome,
                () => detail(optionalValue.id),
                "di-name",
              ),
              node(
                "small",
                null,
                optionalValue.kind === "tutoring"
                  ? "Reforço escolar"
                  : "Escola",
              ),
            );
            const access = node("td", "di-list-access");
            access.dataset.label = "Situação";
            access.append(
              node(
                "span",
                Number(optionalValue.active) ? "di-badge" : "di-badge di-off",
                Number(optionalValue.active) ? "Ativa" : "Desativada",
              ),
            );
            if (!Number(optionalValue.access_enabled))
              access.append(node("small", null, "Login bloqueado"));
            if (optionalValue.expired)
              access.append(
                node("small", "di-expired", "Prazo vencido — revisar"),
              );
            const actions = node("td", "di-list-actions");
            actions.dataset.label = "Gestão";
            actions.append(
              button("Abrir como gestor", () => detail(optionalValue.id, true)),
              button("Editar informações", () => edit(optionalValue)),
              button(
                Number(optionalValue.active) ? "Desativar" : "Reativar",
                () => confirmStatus(optionalValue, list),
                Number(optionalValue.active)
                  ? "di-button di-danger"
                  : "di-button",
              ),
            );
            nodeResult.append(name, access, actions);
            tbody.append(nodeResult);
          }
          table.append(tbody);
          panel.append(table);
          if (!matches.length)
            panel.append(
              node("p", "di-empty", "Nenhuma instituição encontrada."),
            );
        }
        search.oninput = paint;
        paint();
      } catch (error) {
        status(error.message, true);
      }
    }
    function confirmStatus(item, refresh) {
      const box = node("section", "di-confirm");
      box.append(
        node(
          "strong",
          null,
          Number(item.active)
            ? "Desativar " + item.nome + "?"
            : "Reativar " + item.nome + "?",
        ),
        node(
          "p",
          null,
          "Alunos, vínculos, contas e históricos serão preservados.",
        ),
      );
      box.append(
        button(
          "Confirmar",
          () =>
            action(
              () =>
                api("status", item.id, "POST", {
                  active: !Number(item.active),
                }),
              "Status atualizado.",
              refresh,
            ),
          "di-button di-primary",
        ),
        button("Cancelar", () => box.remove()),
      );
      root.prepend(box);
      box.scrollIntoView({
        block: "nearest",
      });
    }
    async function accessGroup(item) {
      if (groupLoading || root.querySelector("dialog[open]")) return;
      groupLoading = true;
      const gen = sequence;
      let dialog;
      try {
        const apiResult = await api("access-group", item.id);
        if (!alive || gen !== sequence) return;
        dialog = node("dialog", "di-access-dialog");
        dialog.setAttribute("aria-labelledby", "di-access-title");
        const heading = node("h2", null, "Acessos por perfil");
        heading.id = "di-access-title";
        dialog.append(heading, node("p", "di-muted", item.nome));
        const form = node("form");
        function section(title, description, definitions, selected, name) {
          const field = node("fieldset", "di-form-section"),
            legend = node("legend", null, title),
            grid = node("div", "di-access-options");
          field.append(legend, node("p", "di-muted", description), grid);
          for (const [key, label] of Object.entries(definitions || {})) {
            const wrap = node("label", "di-access-option"),
              check = node("input");
            check.type = "checkbox";
            check.name = name;
            check.value = key;
            check.checked = (selected || []).includes(key);
            wrap.append(check, node("span", null, label));
            grid.append(wrap);
          }
          form.append(field);
        }
        section(
          "Instituição",
          "Gestão da escola ou reforço. Consulta os materiais e administra os recursos liberados.",
          apiResult.management_definitions,
          apiResult.management_screens,
          "management_screens",
        );
        section(
          "Professor",
          "Consulta os materiais, envia tarefas e acompanha alunos, turmas e relatórios. Não edita conteúdos nem cadastros.",
          apiResult.teacher_definitions,
          apiResult.teacher_screens,
          "teacher_screens",
        );
        section(
          "Aluno",
          "Estuda os materiais e realiza suas tarefas. Não acessa relatórios da equipe nem gestão de alunos, turmas ou professores. O grupo individual pode restringir estes acessos.",
          apiResult.definitions,
          apiResult.access_screens,
          "access_screens",
        );
        const controls = node("div", "di-actions"),
          save = node(
            "button",
            "di-button di-primary",
            "Salvar grupo de acesso",
          );
        save.type = "submit";
        controls.append(
          save,
          button("Cancelar", () => {
            dialog.close();
            dialog.remove();
          }),
        );
        form.append(controls);
        dialog.append(form);
        root.append(dialog);
        form.onsubmit = async (event) => {
          event.preventDefault();
          event.stopPropagation();
          save.disabled = true;
          try {
            const values = new FormData(form);
            const students = values.getAll("access_screens");
            const update = {
              management_screens: values.getAll("management_screens"),
              teacher_screens: values.getAll("teacher_screens"),
            };
            // Keep the existing student policy untouched when only staff guides change.
            if (
              students.length !== apiResult.access_screens.length ||
              students.some((key) => !apiResult.access_screens.includes(key))
            ) {
              update.access_screens = students;
            }
            const saved = await api("access-group", item.id, "PUT", update);
            if (!alive || gen !== sequence) return;
            item.access_screens = saved.access_screens;
            dialog.close();
            dialog.remove();
            status("Grupo de acesso atualizado.");
          } catch (err) {
            status(err.message, true);
            let message = dialog.querySelector("[role=alert]");
            if (!message) {
              message = node("p", "di-access-error");
              message.setAttribute("role", "alert");
              form.prepend(message);
            }
            message.textContent = err.message;
          } finally {
            save.disabled = false;
          }
        };
        dialog.addEventListener("close", () => dialog.remove());
        dialog.showModal();
      } catch (error) {
        dialog?.remove();
        status(error.message, true);
      } finally {
        groupLoading = false;
      }
    }
    function edit(value) {
      ++sequence;
      const resultado = value?.id || 0;
      base(
        resultado ? "Editar instituição" : "Cadastrar instituição",
        "Escola ou reforço com seus próprios acessos e código de inscrição.",
        true,
      );
      const form = node("form", "di-form"),
        general = node("fieldset", "di-form-section"),
        access = node("fieldset", "di-form-section"),
        account = node("fieldset", "di-form-section");
      general.append(node("legend", null, "Identificação e contrato"));
      access.append(node("legend", null, "Acessos e matrícula"));
      account.append(node("legend", null, "Conta da instituição"));
      form.append(general, access, account);
      field(general, "Nome", "nome", "text", value?.nome, {
        required: true,
        maxLength: 100,
      });
      field(general, "Tipo", "kind", "select", value?.kind || "school", {
        options: [
          ["school", "Escola"],
          ["tutoring", "Reforço escolar"],
        ],
      });
      field(
        general,
        "Mensalidade (R$)",
        "monthly_fee",
        "number",
        Number(value?.monthly_fee_cents || 0) / 100,
        {
          min: 0,
          step: "0.01",
          required: true,
        },
      );
      field(
        general,
        "Cor de identificação",
        "cor",
        "color",
        value?.cor || "#4FB3A9",
      );
      field(
        access,
        "Código de inscrição (opcional)",
        "enrollment_code",
        "text",
        value?.enrollment_code,
        {
          minLength: 2,
          maxLength: 100,
          note: "Digite o código que desejar, inclusive o nome do colégio. Sem código, não há inscrição automática.",
        },
      );
      field(
        access,
        "Cota de alunos",
        "max_students",
        "number",
        value?.max_students,
        {
          min: 0,
          note:
            (value?.students_count ?? 0) +
            " alunos cadastrados. Conta todos os cadastros, inclusive inativos. Vazio: sem limite.",
        },
      );
      field(
        access,
        "Cota de professores",
        "max_teachers",
        "number",
        value?.max_teachers,
        {
          min: 0,
          note:
            (value?.teachers_count ?? 0) +
            " acessos de professores cadastrados. Vazio: sem limite.",
        },
      );
      field(
        access,
        "Validade do acesso",
        "access_until",
        "date",
        value?.access_until,
        {
          note: "O vencimento avisa a administração. Não bloqueia automaticamente.",
        },
      );
      field(
        access,
        "Instituição ativa",
        "active",
        "checkbox",
        value ? Number(value.active) : true,
      );
      field(
        access,
        "Login liberado",
        "access_enabled",
        "checkbox",
        value ? Number(value.access_enabled) : true,
        {
          note: "Desmarcar bloqueia o login da instituição e de seus alunos.",
        },
      );
      field(
        access,
        "Inscrição pelo código liberada",
        "enrollment_enabled",
        "checkbox",
        value ? Number(value.enrollment_enabled) : true,
      );
      if (resultado)
        access.append(
          button("Editar grupo de acesso", () => accessGroup(value)),
        );
      field(
        account,
        "E-mail ou apelido de acesso",
        "email",
        "text",
        value?.account?.email,
        {
          required: !resultado,
          minLength: 2,
          maxLength: 254,
        },
      );
      field(
        account,
        value?.account ? "Nova senha (opcional)" : "Senha",
        "password",
        "password",
        "",
        {
          required: !resultado,
          minLength: 6,
          maxLength: 72,
          note: "Mínimo de 6 caracteres. Pode usar uma senha de seis dígitos. Esta senha será usada no login da instituição.",
        },
      );
      field(
        account,
        "Conta do responsável ativa",
        "account_active",
        "checkbox",
        value?.account ? Number(value.account.active) : true,
      );
      const controls = node("div", "di-actions");
      const save = node("button", "di-button di-primary", "Salvar instituição");
      save.type = "submit";
      controls.append(
        save,
        button("Cancelar", () => (resultado ? detail(resultado) : list())),
      );
      form.append(controls);
      root.append(form);
      form.onsubmit = async (event) => {
        event.preventDefault();
        save.disabled = true;
        const instance = new FormData(form),
          fromEntriesResult = Object.fromEntries(instance);
        for (const key of [
          "active",
          "access_enabled",
          "enrollment_enabled",
          "account_active",
        ])
          fromEntriesResult[key] = instance.has(key);
        fromEntriesResult.monthly_fee_cents = Math.round(
          Number(fromEntriesResult.monthly_fee) * 100,
        );
        for (const optionalValue of ["max_students", "max_teachers"])
          fromEntriesResult[optionalValue] =
            fromEntriesResult[optionalValue] === ""
              ? null
              : Number(fromEntriesResult[optionalValue]);
        try {
          if (resultado && typeof value?.sigla !== "string")
            throw new Error(
              "Não foi possível confirmar os dados da instituição. Abra o cadastro novamente.",
            );
          fromEntriesResult.sigla = resultado ? value.sigla : "";
          const apiResult = await api(
            "institutions",
            resultado,
            resultado ? "PUT" : "POST",
            fromEntriesResult,
          );
          await detail(apiResult.id);
          status("Instituição salva.");
        } catch (error) {
          status(error.message, true);
        } finally {
          save.disabled = false;
        }
      };
    }
    async function detail(value, preview = false) {
      if (preview && window.DMInstitutionPortal) {
        ++sequence;
        childDispose?.();
        childDispose = window.DMInstitutionPortal.mount(root, session, {
          institutionId: Number(value),
          preview: true,
          returnTo: list,
        });
        return;
      }
      const gen = ++sequence;
      selected = Number(value);
      base(
        preview ? "Conta da instituição" : "Gerenciar instituição",
        preview
          ? "Visão administrativa desta conta. Você continua como administrador."
          : "Carregando…",
        role === "admin",
      );
      try {
        const res = await api(
          role === "professor" ? "portal" : "institutions",
          value,
        );
        if (!alive || gen !== sequence) return;
        const resultado = res.institution || res;
        if (role === "professor") {
          base("Conta do professor", resultado.nome);
          root.append(
            node(
              "section",
              "di-panel",
              "Sua conta já está vinculada à instituição. As funções pedagógicas do portal serão disponibilizadas na próxima etapa.",
            ),
          );
          return;
        }
        const baseResult = base(
          resultado.nome,
          preview
            ? "Visualização da instituição pela administração."
            : resultado.kind === "tutoring"
              ? "Reforço escolar"
              : "Escola",
          role === "admin",
        );
        if (role === "admin")
          baseResult.append(
            button(
              "Editar dados e acesso",
              () => edit(resultado),
              "di-button di-primary",
            ),
          );
        if (preview)
          root.append(
            node(
              "div",
              "di-preview",
              "Você está visualizando " +
                resultado.nome +
                " como administrador. Nenhum login ou identidade de aluno foi alterado.",
            ),
          );
        if (!Number(resultado.active) || !Number(resultado.access_enabled))
          root.append(
            node(
              "div",
              "di-warning",
              "Acesso desativado. Os cadastros e os históricos continuam preservados.",
            ),
          );
        if (resultado.expired)
          root.append(
            node(
              "div",
              "di-warning",
              "O prazo venceu. Isso é um aviso; a liberação permanece conforme a configuração manual.",
            ),
          );
        const stats = node("div", "di-metrics");
        stats.append(
          metric(
            "alunos cadastrados",
            `${resultado.students_count} / ${resultado.max_students ?? "sem limite"}`,
          ),
          metric("alunos ativos", resultado.active_students_count),
          metric(
            "professores",
            `${resultado.teachers_count} / ${resultado.max_teachers ?? "sem limite"}`,
          ),
          metric("mensalidade", money(resultado.monthly_fee_cents)),
        );
        root.append(stats);
        const info = node("section", "di-panel");
        info.append(node("h2", null, "Código de inscrição"));
        const code = node(
          "code",
          "di-code",
          resultado.enrollment_code || "Nenhum código de inscrição definido.",
        );
        info.append(
          code,
          node(
            "p",
            "di-muted",
            Number(resultado.enrollment_enabled)
              ? "Novos alunos podem usar este código no cadastro. A cota é verificada antes da criação."
              : "Cadastro pelo código está desativado.",
          ),
        );
        if (resultado.enrollment_code)
          info.append(
            button("Copiar código", async () => {
              try {
                await navigator.clipboard.writeText(resultado.enrollment_code);
                status("Código copiado.");
              } catch {
                status("Selecione o código para copiar.");
              }
            }),
          );
        if (role === "admin")
          info.append(
            button("Editar código e informações", () => edit(resultado)),
          );
        root.append(info);
        const tabs = node("nav", "di-tabs");
        const body = node("section", "di-panel");
        tabs.append(
          button("Alunos", () => roster(body, value, false)),
          button("Professores", () => staff(body, value)),
        );
        root.append(tabs, body);
        await roster(body, value, false);
      } catch (error) {
        status(error.message, true);
      }
    }
    async function roster(
      body,
      index,
      all = false,
      indexAtual2 = "",
      page = 1,
    ) {
      body.replaceChildren(
        node("h2", null, all ? "Vincular aluno existente" : "Alunos"),
      );
      const tools = node("div", "di-tools"),
        search = node("input", "di-search");
      search.type = "search";
      search.placeholder = "Nome ou e-mail";
      search.setAttribute("aria-label", "Pesquisar aluno");
      search.value = indexAtual2;
      tools.append(
        search,
        button("Pesquisar", () => roster(body, index, all, search.value, 1)),
      );
      search.onkeydown = (value) => {
        if (value.key === "Enter") roster(body, index, all, search.value, 1);
      };
      if (!all) {
        tools.append(
          button("Cadastrar aluno", () => personForm(body, index, "student")),
        );
        if (role === "admin" && !portal?.section)
          tools.append(
            button("Vincular aluno existente", () => roster(body, index, true)),
          );
      } else
        tools.append(
          button("Voltar aos alunos", () => roster(body, index, false)),
        );
      body.append(tools);
      const result = node("div");
      body.append(result);
      try {
        const apiResult = await api("students", index, "GET", null, {
          q: indexAtual2,
          page,
          all: all ? 1 : 0,
        });
        if (!alive || selected !== Number(index) || !result.isConnected) return;
        result.append(node("p", "di-muted", apiResult.total + " cadastro(s)"));
        const table = node("table", "di-table"),
          head = node("thead"),
          nodeResult = node("tr");
        for (const optionalValue of ["Aluno", "Ano", "Situação", "Ação"])
          nodeResult.append(node("th", null, optionalValue));
        head.append(nodeResult);
        table.append(head);
        const tbody = node("tbody");
        for (const optionalValue of apiResult.items) {
          const row = node("tr"),
            name = node("td");
          name.append(
            node("strong", null, optionalValue.nome),
            node("small", null, optionalValue.usuario),
          );
          row.append(
            name,
            node("td", null, optionalValue.ano || "—"),
            node(
              "td",
              null,
              Number(optionalValue.ativo) ? "Ativo" : "Desativado",
            ),
          );
          const cell = node("td");
          if (all) {
            if (Number(optionalValue.casa_id) === Number(index))
              cell.textContent = "Já vinculado";
            else
              cell.append(
                button("Vincular", () => {
                  const box = node("div", "di-confirm");
                  box.append(
                    node(
                      "p",
                      null,
                      "Vincular " +
                        optionalValue.nome +
                        " a esta instituição? O vínculo atual será alterado e registrado no histórico. A conta e o progresso serão mantidos.",
                    ),
                    button("Confirmar vínculo", () =>
                      action(
                        () =>
                          api("student-link", index, "POST", {
                            student_id: optionalValue.id,
                          }),
                        "Aluno vinculado.",
                        () => detail(index),
                      ),
                    ),
                    button("Cancelar", () => box.remove()),
                  );
                  body.prepend(box);
                }),
              );
          } else
            cell.append(
              button(
                Number(optionalValue.ativo) ? "Desativar" : "Reativar",
                () =>
                  action(
                    () =>
                      api("student-status", index, "POST", {
                        student_id: optionalValue.id,
                        active: !Number(optionalValue.ativo),
                      }),
                    "Situação do aluno atualizada.",
                    () => roster(body, index, false, indexAtual2, page),
                  ),
              ),
            );
          row.append(cell);
          tbody.append(row);
        }
        table.append(tbody);
        const nodeResultAtual2 = node("div", "di-table-wrap");
        nodeResultAtual2.append(table);
        result.append(nodeResultAtual2);
        const pagination = node("div", "di-actions");
        if (page > 1)
          pagination.append(
            button("Anterior", () =>
              roster(body, index, all, indexAtual2, page - 1),
            ),
          );
        if (page * 25 < apiResult.total)
          pagination.append(
            button("Próxima", () =>
              roster(body, index, all, indexAtual2, page + 1),
            ),
          );
        result.append(pagination);
      } catch (error) {
        status(error.message, true);
      }
    }
    async function staff(body, index) {
      body.replaceChildren(
        node("h2", null, "Professores"),
        button("Cadastrar professor", () => personForm(body, index, "teacher")),
      );
      const list = node("div", "di-grid");
      body.append(list);
      try {
        const rows = await api("teachers", index);
        if (!alive || selected !== Number(index) || !list.isConnected) return;
        for (const optionalValue of rows) {
          const nodeResult = node("div", "di-card");
          nodeResult.append(
            node("h3", null, optionalValue.nome),
            node("p", "di-muted", optionalValue.email),
            node(
              "p",
              null,
              Number(optionalValue.active)
                ? "Acesso ativo"
                : "Acesso desativado",
            ),
            button(
              Number(optionalValue.active)
                ? "Desativar acesso"
                : "Reativar acesso",
              () =>
                action(
                  () =>
                    api("teacher-status", index, "POST", {
                      account_id: optionalValue.id,
                      active: !Number(optionalValue.active),
                    }),
                  "Acesso atualizado.",
                  () => staff(body, index),
                ),
            ),
          );
          list.append(nodeResult);
        }
        if (!rows.length)
          list.append(
            node(
              "p",
              "di-muted",
              "Nenhum professor com acesso cadastrado nesta instituição. Cadastros antigos permanecem preservados.",
            ),
          );
      } catch (error) {
        status(error.message, true);
      }
    }
    async function personForm(body, index, type) {
      body.replaceChildren(
        node(
          "h2",
          null,
          type === "student" ? "Cadastrar aluno" : "Cadastrar professor",
        ),
      );
      const form = node("form", "di-form");
      field(form, "Nome", "name", "text", "", {
        required: true,
        maxLength: 100,
      });
      field(form, "E-mail", "email", "email", "", {
        required: true,
        maxLength: 254,
      });
      field(form, "Senha", "password", "password", "", {
        required: true,
        minLength: 6,
        maxLength: 72,
      });
      if (type === "student")
        field(form, "Ano escolar", "year", "text", "", {
          required: true,
          maxLength: 50,
        });
      else if (role === "admin" && !portal?.section) {
        const old = field(
          form,
          "Professor existente (opcional)",
          "teacher_id",
          "select",
          "",
          {
            options: [["", "Criar novo professor"]],
          },
        );
        try {
          for (const optionalValue of await api("legacy-teachers")) {
            const nodeResult = node("option", null, optionalValue.nome);
            nodeResult.value = optionalValue.id;
            old.append(nodeResult);
          }
        } catch {}
        old.onchange = () => {
          form.elements.name.required = !old.value;
        };
      }
      const save = node("button", "di-button di-primary", "Concluir cadastro");
      save.type = "submit";
      form.append(
        save,
        button("Cancelar", () =>
          type === "student" ? roster(body, index, false) : staff(body, index),
        ),
      );
      body.append(form);
      form.onsubmit = async (event) => {
        event.preventDefault();
        save.disabled = true;
        try {
          const fromEntriesResult = Object.fromEntries(new FormData(form));
          await api(
            type === "student" ? "students" : "teachers",
            index,
            "POST",
            fromEntriesResult,
          );
          if (portal?.section) {
            if (type === "student") await roster(body, index, false);
            else await staff(body, index);
          } else await detail(index);
          status("Cadastro concluído.");
        } catch (err) {
          status(err.message, true);
        } finally {
          save.disabled = false;
        }
      };
    }
    if (portal && portal.section) {
      const body = node("section", "di-panel");
      root.replaceChildren(body);
      if (portal.section === "teachers") staff(body, selected);
      else if (portal.section === "student-form")
        personForm(body, selected, "student");
      else roster(body, selected, false);
    } else if (portal) {
      if (!selected) {
        base(
          "Conta institucional",
          "Não foi possível identificar a instituição da sessão.",
        );
        status("Entre novamente com sua conta institucional.", true);
      } else detail(selected);
    } else list();
    return () => {
      alive = false;
      sequence++;
      childDispose?.();
      for (const optionalValue of controllers) optionalValue.abort();
      root.replaceChildren();
      root.classList.remove("di-root");
    };
  }
  window.DMInstitutions = {
    mountSection: (root, session, index, section) =>
      mount(root, session, {
        id: index,
        section,
      }),
    mountManagement: (root, session) => mount(root, session, false),
    mountAdmin: (root, session) => mount(root, session, false),
    mountPortal: (root, session) => mount(root, session, true),
  };
})();
